"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fonts = _interopRequireDefault(require("baseStyles/enums/fonts"));
var _colors = require("baseStyles/enums/colors");
var _types = require("./types");
var _ThemeProvider = require("baseStyles/ThemeProvider");
var _PositionBox = _interopRequireDefault(require("../Box/PositionBox"));
var _Text = _interopRequireDefault(require("../Text"));
var _FlexBox = _interopRequireDefault(require("../Box/FlexBox"));
var _types2 = require("../Box/FlexBox/types");
var _exclamationIcon = _interopRequireDefault(require("./exclamation-icon.svg"));
var _excluded = ["children", "type", "value", "hasError", "onFocus", "onBlur", "onChange", "onClick", "autoFocus", "dataTestId", "customPlaceholder", "icon"];
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var computeValue = function computeValue(value) {
  if (typeof value === "number") {
    return "".concat(value || 0, "px");
  }
  return value;
};
var InputBox = _styledComponents["default"].input(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-style: ", ";\n    width: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    color: ", ";\n    background: transparent;\n    border: ", ";\n    padding: ", ";\n    box-sizing: border-box;\n    border-radius: ", ";\n    height: ", ";\n    ", ";\n\n    :-internal-autofill-selected {\n        color: ", " !important;\n        background: transparent;\n        appearance: none;\n    };\n\n    ::placeholder {\n        color: ", ";\n        opacity: ", ";\n    };\n    ", ";\n     &:focus {\n        ", "\n    };\n    &:disabled {\n        pointer-events: none;\n        opacity: 1;\n    };\n    ", ";\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n"])), _fonts["default"].Family.GRAPHIE, _fonts["default"].Style.NORMAL, function (props) {
  return props.width ? computeValue(props.width) : '100%';
}, function (props) {
  return computeValue(props.fontSize) || "".concat(_fonts["default"].Size.S14, "px");
}, function (props) {
  return props.fontWeight || _fonts["default"].Weight.W400;
}, function (props) {
  return computeValue(props.lineHeight) || "".concat(_fonts["default"].Height.H20, "px");
}, function (props) {
  var _props$theme;
  return props.color || ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.colorSecondary);
}, function (props) {
  var _props$theme2;
  return computeValue(props.border) || "1px solid ".concat((_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.border);
}, function (props) {
  return computeValue(props.padding) || '10px';
}, function (props) {
  return computeValue(props.borderRadius) || '800px';
}, function (props) {
  return props !== null && props !== void 0 && props.height ? props.height + 'px' : 'auto';
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.hideBorder) && "\n        border: none;\n    ";
}, function (props) {
  var _props$theme3;
  return props.color || ((_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.colorSecondary);
}, function (props) {
  var _props$theme4;
  return props.placeholderColor || props.color || ((_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.colorSecondary);
}, function (props) {
  return props.placeholderOpacity;
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.outline) && "outline: ".concat(props === null || props === void 0 ? void 0 : props.outline, ";");
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.focusBorder) && "border: ".concat(props === null || props === void 0 ? void 0 : props.focusBorder);
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.backgroundColor) && "background: ".concat(props === null || props === void 0 ? void 0 : props.backgroundColor, ";");
});
var Input = function Input(_ref) {
  var children = _ref.children,
    type = _ref.type,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    hasError = _ref.hasError,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    autoFocus = _ref.autoFocus,
    dataTestId = _ref.dataTestId,
    customPlaceholder = _ref.customPlaceholder,
    icon = _ref.icon,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSuiTheme = (0, _ThemeProvider.useSuiTheme)(),
    theme = _useSuiTheme.theme;
  var _useState = (0, _react.useState)(value),
    _useState2 = _slicedToArray(_useState, 2),
    customText = _useState2[0],
    setCustomText = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocused = _useState4[0],
    setIsFocused = _useState4[1];
  var inputRef = (0, _react.useRef)(null);
  var handleOnChange = function handleOnChange(event) {
    var _event$target;
    setCustomText(event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
  };
  var onFocusHandler = function onFocusHandler(event) {
    setIsFocused(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
  };
  var onBlurHandler = function onBlurHandler(event) {
    setTimeout(function () {
      return setIsFocused(false);
    }, 150);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
  };
  var characterLimitReached = (0, _react.useMemo)(function () {
    return (customText === null || customText === void 0 ? void 0 : customText.length) > (props === null || props === void 0 ? void 0 : props.maxCharacters);
  }, [customText, props === null || props === void 0 ? void 0 : props.maxCharacters]);
  if (customPlaceholder) {
    return /*#__PURE__*/_react["default"].createElement(_PositionBox["default"].relative, null, (customText === null || customText === void 0 ? void 0 : customText.length) > 0 || isFocused ? /*#__PURE__*/_react["default"].createElement(_PositionBox["default"].absolute, {
      backgroundColor: _colors.Colors.WHITE,
      top: -10,
      left: 24,
      padding: "0 4px",
      width: "auto"
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"].CAPTION, {
      letterSpacing: 0.4,
      color: hasError ? _colors.Colors.DARK_RED_2 : isFocused ? _colors.Colors.PURE_PURPLE : _colors.Colors.CONTENT_TEXT_TERTIARY
    }, props === null || props === void 0 ? void 0 : props.placeholder)) : null, /*#__PURE__*/_react["default"].createElement(InputBox, _extends({
      "data-test-id": dataTestId,
      ref: inputRef,
      onFocus: onFocusHandler,
      autoFocus: autoFocus,
      onBlur: onBlurHandler,
      value: value,
      onChange: handleOnChange,
      onClick: onClick,
      type: type,
      className: "sui-input",
      "data-test-class": "sui-input",
      theme: theme
    }, props, {
      border: characterLimitReached || hasError ? "1px solid ".concat(_colors.Colors.DARK_RED_2) : '',
      focusBorder: characterLimitReached || hasError ? "1px solid ".concat(_colors.Colors.DARK_RED_2, " !important") : '',
      autoComplete: "off",
      placeholder: isFocused ? "" : props.placeholder
    })), icon ? /*#__PURE__*/_react["default"].createElement(_PositionBox["default"].absolute, {
      top: 18,
      right: 24
    }, icon) : null, props !== null && props !== void 0 && props.maxCharacters && isFocused ? /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
      margin: "4px 0 0 0",
      fullWidth: true,
      justifyContent: characterLimitReached ? _types2.FlexProps.JustifyContent.SPACE_BETWEEN : _types2.FlexProps.JustifyContent.FLEX_END,
      alignItems: _types2.FlexProps.AlignItems.CENTER
    }, characterLimitReached ? /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
      alignItems: _types2.FlexProps.AlignItems.CENTER,
      gap: 4
    }, /*#__PURE__*/_react["default"].createElement(_exclamationIcon["default"], null), /*#__PURE__*/_react["default"].createElement(_Text["default"].CAPTION, {
      letterSpacing: 0.4,
      color: _colors.Colors.DARK_RED_2
    }, "Character limit reached")) : null, /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], null, /*#__PURE__*/_react["default"].createElement(_Text["default"].CAPTION, {
      letterSpacing: 0.4,
      color: characterLimitReached ? _colors.Colors.DARK_RED_2 : _colors.Colors.CONTENT_TEXT_TERTIARY
    }, customText === null || customText === void 0 ? void 0 : customText.length, "/", props === null || props === void 0 ? void 0 : props.maxCharacters, " characters"))) : null);
  }
  return /*#__PURE__*/_react["default"].createElement(InputBox, _extends({
    "data-test-id": dataTestId,
    onFocus: onFocus,
    autoFocus: autoFocus,
    onBlur: onBlur,
    value: value,
    onChange: onChange,
    onClick: onClick,
    type: type,
    className: "sui-input",
    "data-test-class": "sui-input",
    theme: theme
  }, props, {
    autoComplete: "off",
    "data-sentry-element": "InputBox",
    "data-sentry-component": "Input",
    "data-sentry-source-file": "index.tsx"
  }));
};
Input[_types.InputTypes.TEXT] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Input, _extends({
    type: _types.InputTypes.TEXT
  }, props));
};
Input[_types.InputTypes.PASSWORD] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Input, _extends({
    type: _types.InputTypes.PASSWORD
  }, props));
};
var _default = Input;
exports["default"] = _default;